"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Seaport = void 0;
var seaport_1 = require("./seaport");
Object.defineProperty(exports, "Seaport", { enumerable: true, get: function () { return seaport_1.Seaport; } });
//# sourceMappingURL=index.js.map